import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { AppNav } from "@/components/AppNav";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { useAuthDialog } from "@/context/AuthDialogContext";
import { WelcomeInvite } from "@/components/WelcomeInvite";
import { PathChoice, markReturning } from "@/components/PathChoice";

export default function Home() {
  useLang();
  const { user, ready } = useAuth();
  const authDialog = useAuthDialog();
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);

  const loadSummary = () => { api.get("/home").then(({ data }) => setSummary(data)).catch(() => setSummary({ total: 0, counts: {}, focus: null })); };
  useEffect(() => { if (ready && user) { loadSummary(); markReturning(); } }, [ready, user]);



  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <Navbar onStart={() => navigate("/app/home")} onLogin={() => authDialog.openAuth(() => navigate("/app/home"))} />
      <main className="max-w-6xl mx-auto px-5">
        <section className="min-h-[100svh] flex flex-col justify-center pt-4 pb-28 md:pb-24" data-testid="home-section-path">
          {user && <WelcomeInvite builderProfile={user.builder_profile} />}
          <div className="mx-auto w-full max-w-3xl cpenz-panel px-5 py-8 sm:px-10 sm:py-14 border border-white/10" data-testid="home-path">
            <PathChoice greetingName={(user?.name || "").split(" ")[0]} compact dark />
          </div>
        </section>
      </main>
      <AppNav />
    </div>
  );
}
